export function getTheme() {
  /**
   *  Randomize theme
   *
   */
  let myTheme = [
    {
      bgColor: "#09263E",
      textColor: "#C9B97E",
    },
    {
      bgColor: "#fbedc0",
      textColor: "#d54f02",
    },
    {
      bgColor: "#fbedc0",
      textColor: "#20396E",
    },
    {
      bgColor: "#7BD6C0",
      textColor: "#104c91",
    },
    {
      bgColor: "#efc9af",
      textColor: "#104c91",
    },
  ]

  let randomTheme = myTheme[Math.floor(Math.random() * myTheme.length)]

  let staticTheme = myTheme[2]

  return staticTheme
}
